const conversionFunctions: {
  [key: string]: any;
} = {};

conversionFunctions["astros"] = require("./BASEBALL/astros").default;
conversionFunctions["brewers"] = require("./BASEBALL/brewers").default;
conversionFunctions["marlins"] = require("./BASEBALL/marlins").default;
conversionFunctions["rangers"] = require("./BASEBALL/rangers").default;
conversionFunctions["clippers"] = require("./BASKETBALL/clippers").default;
conversionFunctions["pittsburgh-panthers"] =
  require("./COLLEGE/pittsburgh-panthers").default;
conversionFunctions["windsurge"] =
  require("./MINOR_BASEBALL/windsurge").default;
conversionFunctions["reign"] = require("./MINOR_HOCKEY/reign").default;
conversionFunctions["frontwavearena"] =
  require("./MULTI/frontwavearena").default;
conversionFunctions["la-kings"] = require("./HOCKEY/la-kings").default;
export default conversionFunctions;
